import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { useTranslatedMessages } from '../../../../hooks/useTranslatedMessages';

const formatAed = (value, currency = 'AED') => `${currency} ${Number(value ?? 0).toLocaleString()}`;

const SummaryMetric = ({ icon, label, value, emphasize = false }) => (
  <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
    <Box sx={{ color: emphasize ? 'primary.main' : 'text.secondary', display: 'flex' }}>{icon}</Box>
    <Typography
      variant="caption"
      sx={{
        textTransform: 'uppercase',
        letterSpacing: 0.6,
        fontWeight: 600,
        fontSize: 10,
        color: emphasize ? 'primary.main' : 'text.secondary',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="body1"
      fontWeight={700}
      sx={{
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 16,
        color: emphasize ? 'primary.main' : 'text.primary',
        whiteSpace: 'nowrap',
      }}
    >
      {value}
    </Typography>
  </Stack>
);

const VatSummaryBar = ({ summary }) => {
  const { misDashboard: m } = useTranslatedMessages();
  const currency = summary?.currency ?? 'AED';

  return (
    <Paper variant="outlined" sx={{ px: 2, py: 2, borderRadius: 2 }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', md: 'center' }}
        spacing={2}
        gap={3}
      >
        <SummaryMetric
          icon={<TrendingUpIcon sx={{ fontSize: 16 }} />}
          label={m.vat?.total_sales ?? 'Total Sales'}
          value={formatAed(summary?.total_sales, currency)}
        />
        <SummaryMetric
          icon={<TrendingDownIcon sx={{ fontSize: 16 }} />}
          label={m.vat?.total_purchases ?? 'Total Purchase'}
          value={formatAed(summary?.total_purchases, currency)}
        />
        <SummaryMetric
          icon={<AccountBalanceIcon sx={{ fontSize: 16 }} />}
          label={m.vat?.vat_liability ?? 'VAT Liability'}
          value={formatAed(summary?.vat_liability, currency)}
          emphasize
        />
      </Stack>
    </Paper>
  );
};

export default VatSummaryBar;
